/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import { Tag as AntTag } from 'antd';
import { TagProps } from 'antd/es/tag';
import classNames from 'classnames';
import styles from './Tag.module.less';

interface IButtonProps extends TagProps {
  isRounded?: boolean;
}

const Tag: React.FC<IButtonProps> = ({ children, isRounded, ...props }) => (
  <AntTag {...props} className={classNames({ [styles.rounded]: isRounded })}>
    {children}
  </AntTag>
);

export default Tag;
